export interface SensorsWidgetConfig {
  /** Home whose sensors to render. `null` until the user picks one in settings. */
  homeId: string | null;
  /** Sensor ids to show. Empty array = show all sensors of the home. */
  sensorIds: string[];
  /** Refetch interval, seconds. Clamped to MIN/MAX. */
  pollSeconds: number;
}

export const DEFAULT_SENSORS_CONFIG: SensorsWidgetConfig = {
  homeId: null,
  sensorIds: [],
  pollSeconds: 60,
};

export const POLL_SECONDS_MIN = 10;
export const POLL_SECONDS_MAX = 3600;

export function mergeSensorsConfig(partial: Partial<SensorsWidgetConfig> | null | undefined): SensorsWidgetConfig {
  const p = partial ?? {};
  const homeId = typeof p.homeId === 'string' && p.homeId !== '' ? p.homeId : null;
  const sensorIds = Array.isArray(p.sensorIds) ? p.sensorIds.filter((v): v is string => typeof v === 'string' && v !== '') : [];
  const rawPoll = typeof p.pollSeconds === 'number' && Number.isFinite(p.pollSeconds) ? p.pollSeconds : DEFAULT_SENSORS_CONFIG.pollSeconds;
  const pollSeconds = Math.min(Math.max(Math.round(rawPoll), POLL_SECONDS_MIN), POLL_SECONDS_MAX);
  return { homeId, sensorIds, pollSeconds };
}
